module.exports = __webpack_public_path__ + "img/saint_exupery.d72b78b5.jpg";